import React,{useState} from "react";
import SectorCard from "./sectorsCard";

export default function SalesCard({ flight }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="flight-card content-tabs">
      <div className="flight-header flexRow" onClick={() => setOpen(!open)}>
        <div className="flexRow justifyContentFlexStart alignItemsCenter textAlignCenter">
         <div className="flexRow flight-header-count"><h4 className="it">{flight.id}&nbsp;</h4></div>
         <div className="flexRow margRight30 flight-header-count"><h6 className="total">of&nbsp;11 </h6></div>
              <div className="flexCol justifyContentFlexStart">
         <div className="flexRow justifyContentFlexStart"><h3>{flight.route}</h3>
</div>
         <div className="flexRow alignItemsCenter"> <p>
            Uplift: {flight.uplift} · {flight.date} · Sectors: {flight.sectors.map(s => s.name).join(", ")}
          </p></div>


        </div>
        </div>

        <div>

        </div>
        <div className="flexRow content-tabs justifyContentCenter alignItemsCenter">
          <span>{flight.posPending} POS Pending</span>

        </div>
        <div className="flexRow">


            <div className="flexCol justifyContentFlexStart">
         <div className="flexRow justifyContentEnd"> <strong>Total Group Sales</strong>
</div>
         <div className="flexRow alignItemsCenter"> <p>
          {flight.groupSales}
          </p></div>


        </div>


        </div>
      </div>
      {open && (
        <div className="sector-list">
          {flight.sectors.map((sector) => (
            <SectorCard sector={sector} key={sector.id} />
          ))}
        </div>
      )}
    </div>
  );
}
